class NewsletterPopup extends HTMLElement {
  constructor() {
    super();
    this.popup = this.querySelector('.newsletter-popup');
    this.closeBtn = this.querySelector('.newsletter-popup__close');
    this.form = this.querySelector('form');
    this.delay = parseInt(this.dataset.delay, 10) || 15000;
    this.exitIntentHandler = this.handleExitIntent.bind(this);
    this.daysToHide = parseInt(this.dataset.days) || 7;
    
    // Check if form was just successfully submitted
    this.isSuccess = this.dataset.success === 'true';

    this.init();
  }

  init() {
    if (this.isSuccess) {
      // Show immediately if successful, then block permanently
      if (this.closeBtn) this.closeBtn.addEventListener('click', this.closePopup.bind(this));
      this.showPopup();
      this.setCookie('newsletter_popup_subscribed', 'true', 365);
      return;
    }

    if (this.shouldShowPopup()) {
      // Logic for exit intent (desktop)
      document.addEventListener('mouseleave', this.exitIntentHandler);

      // Logic for time delay (all devices)
      this.showTimer = setTimeout(() => {
        if (this.shouldShowPopup()) this.showPopup();
      }, this.delay);
    }

    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', this.closePopup.bind(this));
    }

    // Click outside to close
    this.addEventListener('click', (e) => {
      if (e.target === this) {
        this.closePopup();
      }
    });

    // Klaviyo birthday sync on submit
    if (this.form) {
      this.form.addEventListener('submit', this.handleKlaviyoSubmit.bind(this));
    }
  }

  handleKlaviyoSubmit(e) {
    const klaviyo = window.klaviyo || [];
    const email = document.getElementById('NewsletterPopup-email')?.value;

    if (email && klaviyo) {
      klaviyo.push(['identify', {
        '$email': email
      }]);
      klaviyo.push(['track', 'Subscribed to Newsletter', {
        '$email': email
      }]);
    }
  }

  handleExitIntent(e) {
    if (e.clientY < 0 && this.shouldShowPopup()) {
      this.showPopup();
    }
  }

  shouldShowPopup() {
    return !this.getCookie('newsletter_popup_hidden') && !this.getCookie('newsletter_popup_subscribed');
  }

  showPopup() {
    const editingField = document.activeElement?.matches('input, textarea, select, [contenteditable="true"]');
    const shoppingCart = document.querySelector('cart-drawer.active');
    const cartPage = /\/cart(?:\/|$)/.test(window.location.pathname);
    if (!this.isSuccess && (editingField || shoppingCart || cartPage || !this.shouldShowPopup())) return;
    if (!this.popup.classList.contains('is-visible')) {
      this.popup.classList.add('is-visible');
      this.classList.add('is-visible');
      document.body.style.overflow = 'hidden';
      // Remove exit intent listener once triggered
      document.removeEventListener('mouseleave', this.exitIntentHandler);
    }
  }

  closePopup() {
    clearTimeout(this.showTimer);
    document.removeEventListener('mouseleave', this.exitIntentHandler);
    this.popup.classList.remove('is-visible');
    this.classList.remove('is-visible');
    document.body.style.overflow = '';
    
    if (!this.isSuccess) {
      this.setCookie('newsletter_popup_hidden', 'true', this.daysToHide);
    }
  }

  setCookie(name, value, days) {
    let expires = "";
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/; SameSite=Lax";
  }

  getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for(let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }
}

customElements.define('newsletter-popup', NewsletterPopup);
